import script from "./WReportHeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./WReportHeader.vue?vue&type=script&lang=ts&setup=true"

import "./WReportHeader.vue?vue&type=style&index=0&id=02969175&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02969175"]])

export default __exports__